"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlCtepParameterLogValidation = void 0;
const ChargerControlCtepParameterValidation_1 = require("./ChargerControlCtepParameterValidation");
class ChargerControlCtepParameterLogValidation {
    static isValid(entity) {
        // Validate entity.log_entries for existence and correct type.
        if (entity.log_entries == undefined)
            return false;
        if (!Array.isArray(entity.log_entries))
            return false;
        if (!entity.log_entries.every((elem) => {
            if (!ChargerControlCtepParameterValidation_1.ChargerControlCtepParameterValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ChargerControlCtepParameterLogValidation = ChargerControlCtepParameterLogValidation;
